import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, ICompanySettings } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useCompanySettings(config: customSWRConfig = {}): customSWRResponse<ICompanySettings[]> {
    const keys = useSWRCacheKeys('/settings');

    return useSWR<ICompanySettings[]>(keys, { ...config });
}
